import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.state';
import { DeliverableTemplateFormDialogComponent } from '../../components/deliverable-template-form-dialog/deliverable-template-form-dialog.component';
import { openDeleteConfirmationDialog } from 'src/app/shared/store/action-dialog/action-dialog.actions';
import { deleteDADeliverableTemplate, loadAllDADeliverablesTemplates } from '../../store/global-settings.actions';

@Component({
  standalone: false,
  selector: 'app-deliverable-templates',
  templateUrl: './deliverable-templates.component.html',
  styleUrl: './deliverable-templates.component.scss'
})
export class DeliverableTemplatesComponent {

  constructor(private store: Store<AppState>, private dialog: MatDialog) {
    this.store.dispatch(loadAllDADeliverablesTemplates());
  }

  addDADeliverableTemplate() {
    this.openDADeliverableTemplateFormDialog();
  }

  editDADeliverableTemplate(daDeliverableTemplateId: string) {
      this.openDADeliverableTemplateFormDialog(daDeliverableTemplateId);
    }
  
    deleteDADeliverableTemplate(daDeliverableTemplateId: string) {
      this.store.dispatch(
        openDeleteConfirmationDialog({
          onConfirm: () => {
            this.store.dispatch(
              deleteDADeliverableTemplate({ daDeliverableTemplateId })
            );
          },
          description:
            'are you sure you want to delete the selected DA deliverable template? you cannot undo this action.',
        })
      );
    }

  private openDADeliverableTemplateFormDialog(
      daDeliverableTemplateId: string | null = null
    ) {
      const dialogRef = this.dialog.open(
        DeliverableTemplateFormDialogComponent,
        {
          panelClass: 'deliverable-template-form-dialog',
          closeOnNavigation: false,
          disableClose: true,
          maxWidth: 'unset',
          data: daDeliverableTemplateId,
        }
      );
      dialogRef.afterClosed().subscribe(() => {
        dialogRef.componentInstance.closeWindow();
      });
    }
}
